import { Driver, Vehicle, VehicleGroup } from '@api/index';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';

import { useAppDispatch } from '../../../setup/store';
import { createReportConfiguration } from '../reducer';
import { ReportForm } from '../types';
import Form from './Form';
import { handleFormData } from './handleFormData';

type Props = {
    vehicles: Vehicle[];
    drivers: Driver[];
    groups: VehicleGroup[];
    report: Omit<ReportForm, 'id'>;
    onCloseDialog: () => void;
    setIsSubmitting: (s: boolean) => void;
    setHasError: (e: boolean) => void;
};

const CreateReportForm = ({
    vehicles,
    groups,
    drivers,
    report,
    onCloseDialog,
    setIsSubmitting,
    setHasError,
}: Props) => {
    const dispatch = useAppDispatch();
    const formApi = useForm<ReportForm>({
        defaultValues: report,
    });

    const {
        formState: { errors },
    } = formApi;

    useEffect(() => {
        setHasError(Object.keys(errors).length > 0);
    }, [errors, formApi, setHasError]);

    const onSubmit = (data: ReportForm) => {
        setIsSubmitting(true);
        dispatch(createReportConfiguration(handleFormData(data, groups))).then((res) => {
            setIsSubmitting(false);
            if (res.meta.requestStatus !== 'rejected') {
                onCloseDialog();
            }
        });
    };

    return (
        <form onSubmit={formApi.handleSubmit(onSubmit)}>
            <Form formApi={formApi} vehicles={vehicles} groups={groups} drivers={drivers} />
        </form>
    );
};

export default CreateReportForm;
